export default __webpack_public_path__ + "static/media/global-icon-three-hover.38048f56.svg";